"use strict";
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.useAcTableData = void 0;
var react_1 = require("react");
var AcTableColumn_1 = require("./AcTableColumn");
var AcTableItem_1 = require("./AcTableItem");
/**
 * AcTable Data Storage and Processing
 */
var useAcTableData = function (props) {
    var _a = __read(react_1.useState(AcTableColumn_1.AcTableColumn.fromColumns(props.columns)), 2), acTableColumns = _a[0], setAcTableColumns = _a[1];
    var _b = __read(react_1.useState(AcTableItem_1.AcTableItem.fromData(props.data, props.functionContext)), 2), acTableItems = _b[0], setAcTableItems = _b[1];
    /**
     * Refresh columns state with a new configuration
     * @param data
     */
    var setColumns = function (columns) {
        return setAcTableColumns(AcTableColumn_1.AcTableColumn.fromColumns(columns));
    };
    var setData = function (data) {
        return setAcTableItems(AcTableItem_1.AcTableItem.fromData(data));
    };
    return {
        acTableColumns: acTableColumns,
        setAcTableColumns: setAcTableColumns,
        acTableItems: acTableItems,
        setAcTableItems: setAcTableItems,
        setColumns: setColumns,
        setData: setData,
    };
};
exports.useAcTableData = useAcTableData;
exports.default = useAcTableData;
//# sourceMappingURL=UseAcTableData.js.map